import { render, staticRenderFns } from "./FoodServiceTabSelect.vue?vue&type=template&id=77b76964&scoped=true"
import script from "./FoodServiceTabSelect.vue?vue&type=script&lang=js"
export * from "./FoodServiceTabSelect.vue?vue&type=script&lang=js"
import style0 from "./FoodServiceTabSelect.vue?vue&type=style&index=0&id=77b76964&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b76964",
  null
  
)

export default component.exports